module.exports = __webpack_public_path__ + "img/jfban.71bd5a79.png";